<template>
  <div>
    <template v-for="(conceptKey, i) in Object.keys(aggregations)">
      <div v-if="i === 0" :key="'title' + conceptKey" class="px-3 pt-3">
        <div class="d-flex justify-content-between">
          <h3 v-html="translatedLabel('refineSearch', 'servicelibrary_ServiceLibraryComponent')" />

          <b-link v-if="Object.keys(facetFilter).length > 0 && Object.values(facetFilter).reduce((r, k) => { return r + k.length }, 0)"
                  class="flex-column small mb-2 font-condensed"
                  @click="$emit('clearAll')"
          >
            {{ 'clearAll' | translate(labels, 'shared_CommonFunctional') }}
          </b-link>
        </div>
      </div>
      <hr v-else :key="'sep_' + conceptKey" class="m-0">
      <div :key="'category_' + conceptKey" class="p-3">
        <div class="d-flex justify-content-between">
          <h4>{{ conceptKey | translate(labels, 'servicelibrary_ServiceLibraryFilters') }} ({{ aggregations[conceptKey]._counter }})</h4>

          <b-link v-if="(conceptKey in facetFilter) && facetFilter[conceptKey].length > 0"
                  class="flex-column small font-condensed"
                  @click="$emit('clear', conceptKey)"
          >
            {{ 'clearLabel' | translate(labels, 'shared_CommonFunctional') }}
          </b-link>
        </div>
        <b-form-checkbox-group v-model="facetFilter[conceptKey]" stacked>
          <template v-for="facet in Object.keys(aggregations[conceptKey]).filter(x => x !== '_counter').splice(0,10)">
            <b-form-checkbox :key="'facet_' + facet"
                             :value="facet"
                             :disabled="!facetFilter[conceptKey].indexOf(facet) >= 0 && aggregations[conceptKey][facet] === 0"
            >
              <template v-if="conceptKey === 'locale_filter'">
                {{ translateLocale(facet) }}
              </template>
              <template v-else>
                {{ facet | translateFallback(labels, 'servicelibrary_ServiceLibraryFacets') }}
              </template>
              ({{ aggregations[conceptKey][facet] }})
            </b-form-checkbox>
          </template>
        </b-form-checkbox-group>
        <div v-if="Object.keys(aggregations[conceptKey]).length > 10">
          <b-collapse :id="conceptKey">
            <b-form-checkbox-group v-model="facetFilter[conceptKey]" stacked>
              <template v-for="facet in Object.keys(aggregations[conceptKey]).filter(x => x !== '_counter').splice(10)">
                <b-form-checkbox :key="'facet_' + facet"
                                 :value="facet"
                                 :disabled="!facetFilter[conceptKey].indexOf(facet) >= 0 && aggregations[conceptKey][facet] === 0"
                >
                  {{ conceptKey === 'locale_filter' ?
                    translateLocale(facet) : facet |
                    translateFallback(labels, 'servicelibrary_ServiceLibraryFacets') }}
                  ({{ aggregations[conceptKey][facet] }})
                </b-form-checkbox>
              </template>
            </b-form-checkbox-group>
          </b-collapse>
          <div class="mt-2">
            <b-link v-b-toggle="conceptKey" class="btn-collapse font-condensed">
              {{ 'showMore' | translate(labels, 'servicelibrary_ServiceLibraryComponent') }}
              <span v-if="isHiddenSelected(conceptKey)">
                {{ 'selected' | translate(labels, 'servicelibrary_ServiceLibraryComponent') | replace('[n]', isHiddenSelected(conceptKey)) }}
              </span>
            </b-link>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import langs from 'langs'

export default {
  conceptName: [
    'shared_CommonFunctional',
    'servicelibrary_ServiceLibraryFilters',
    'servicelibrary_ServiceLibraryComponent',
    'servicelibrary_ServiceLibraryFacets'
  ],
  props: {
    aggregations: {
      required: true
    },
    facetFilter: {
      required: true
    }
  },
  data() {
    return {
      langs: langs
    }
  },
  methods: {
    isHiddenSelected(filter) {
      const showMoreKeys = Object.keys(this.aggregations[filter]).filter(x => x !== '_counter').splice(10)
      const selectedFilters = this.facetFilter[filter]
      const innerJoin = showMoreKeys.filter(value => selectedFilters.includes(value))
      return innerJoin.length
    }
  }
}
</script>
<style lang="scss">
.btn-collapse.not-collapsed {
  display: none;
}
</style>
